/**
 * Created by tpetridis on 7/2/2017.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common/index';
import game from './modules/game/index';
import i18n from './modules/i18n/index';
import profile from './modules/profile/index';
import users from './modules/users/index';
import chat from './modules/chat/index';
import registration from './modules/registration/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    game,
    i18n,
    profile,
    users,
    chat,
    registration,
  },
  strict: false,
});



// WEBPACK FOOTER //
// ./src/store/index.js